
import React, { useEffect, useRef, useState } from "react";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { MDBDataTableV5 } from "mdbreact";
import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import MyBragSheetTableInput from "./MyBragSheetTableInput";
// import EditIcon from "@mui/icons-material/Edit";

const MyBragSheetTable = (props) => {
    return (
        <Card className="p-3">
            {props.children}
            <hr />
            <CardBody
                className="bg-light"
            >
                <MDBDataTableV5
                    id={props.id}
                    hover
                    responsive
                    borderless={false}
                    bordered
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={5}
                    pagesAmount={4}
                    data={props.data}
                    fullPagination={false}
                    paging={false}
                    searchTop
                    searchBottom={false}
                />
                {
                    props.editable ?
                        <IconButton
                            color="primary"
                            onClick={() => {
                                const tmp = {}
                                props.addFunc()
                            }}
                        >
                            <AddCircleIcon fontSize="large" />
                        </IconButton>
                        : null
                }
            </CardBody>

            {
                props.saveFlag ? (
                    <div className="text-center d-flex">
                        <button
                            className="btn btn-primary fw-bolder mx-auto w-25"
                            onClick={props.saveFunction}
                        >
                            Save
                        </button>
                    </div>
                )
                    : null
            }
        </Card>
    )
}

export default MyBragSheetTable